import type { ReactElement } from 'react';

export enum EAsidePromoModalTheme {
    dark = 'dark',
    modalDark = 'modalDark',
}

export interface IAsidePromoModalProps {
    title: string | ReactElement;
    text: string | ReactElement;
    note?: string;
    imageUrl?: string;
    buttonText?: string;
    href?: string;
    onShow?: () => void;
    onClick?: () => void;
    onClose?: () => void;
    onSecondaryClick?: () => void;
    fixed?: boolean;
    theme?: EAsidePromoModalTheme;
    bottom?: number;
    qrUrl?: string;
    qaId?: string;
    showAboveViewer?: boolean;
    textCompact?: boolean;
    darkClose?: boolean;
    closeOnNavigation?: boolean;
    // tempexp_17821-start
    alwaysDark?: boolean;
    imageText?: string;
    // tempexp_17821-end
    // tempexp_18060-next-line
    blackFriday2024Modal?: boolean;
    cyberMonday2025Modal?: boolean;
    closable?: boolean;
    secondaryText?: string;
}
